import * as React from 'react';

const SvgIconAvailable = (props) => (
  <svg viewBox="0 0 5 4" fill="none" width="4" height="4" xmlns="http://www.w3.org/2000/svg" data-icon="1" {...props}>
    <circle cx={2.5} cy={2} r={2} fill="#EB0A1E" />
  </svg>
);

export default SvgIconAvailable;
